export default __webpack_public_path__ + "locales/it/Ldap.json?hash=5c8a2a50392b1d3f2f9a1aabca7a4c63";